import { AmplitudeEvents } from "../types/amplitudeEvents"
import { sendAmplitudeData } from "./amplitude"

export const startMixerHandler = (
  templateCode,
  amplitudeEvent,
  setIsModalVisible
) => {
  if (window?.innerWidth < 800) {
    // The body scroll should be disable when the modal is open
    const body = document.querySelector("body")
    body.style.overflow = "hidden"
    sendAmplitudeData(AmplitudeEvents.SHARE_MODAL_OPENED)
    setIsModalVisible(true)
  } else {
    let mixerLink = ""
    if (templateCode.length > 0) {
      const createSocialLink = process.env.THURSDAY_CREATE_SOCIAL_URL
      mixerLink = `${createSocialLink}?auto=true&templateCode=${templateCode}`
    } else {
      const thursdayLink = process.env.THURSDAY_SIGNIN_URL
      mixerLink = `${thursdayLink}?auto=true&templateCode=aba81eeb-6275-4b2f-be80-3fee8082acf5`
    }
    sendAmplitudeData(amplitudeEvent)
    window.location.href = mixerLink
  }
}
